export const BUCKET_URL = 'https://storage.googleapis.com/ezyagric-media'
